var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModelTypeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26.195,
    height: 24,
    rx: 3.91304,
    transform: "matrix(-1 0 0 1 26.1953 0)",
    fill: "#C5DEFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 8.25H15.75V14.75H9.25V8.25Z",
    stroke: "#3982DE",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 14.75L18.4312 17.4312M15.75 8.25L18.4312 5.56875M9.25 8.25L6.56875 5.56875M9.25 14.75L6.56875 17.4312M6 6.625C6 6.19402 6.1712 5.7807 6.47595 5.47595C6.7807 5.1712 7.19402 5 7.625 5H17.375C17.806 5 18.2193 5.1712 18.524 5.47595C18.8288 5.7807 19 6.19402 19 6.625V16.375C19 16.806 18.8288 17.2193 18.524 17.524C18.2193 17.8288 17.806 18 17.375 18H7.625C7.19402 18 6.7807 17.8288 6.47595 17.524C6.1712 17.2193 6 16.806 6 16.375V6.625Z",
    stroke: "#3982DE",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelTypeIcon);
export default __webpack_public_path__ + "static/media/modelTypeIcon.207842b52901cc6c40191c20e688bb3b.svg";
export { ForwardRef as ReactComponent };